import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-sovereign-gold text-sovereign-navy hover:bg-sovereign-gold-light border border-transparent',
    secondary: 'bg-sovereign-navy text-white hover:bg-sovereign-navy-light border border-transparent',
    outline: 'bg-transparent border-sovereign-gold text-sovereign-gold hover:bg-sovereign-gold/10',
    ghost: 'bg-transparent text-sovereign-navy hover:text-sovereign-gold hover:bg-sovereign-navy/5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center rounded-sm font-medium transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-sovereign-gold focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-widest', variants[variant], sizes[size], className)} {...props} data-id="element-150">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';
export { Button };